<app-pcbread-crumb [data]="'Buy,FactorList'"></app-pcbread-crumb>
<app-factor-table [endPoint]="'BuyFactor'"></app-factor-table>